class Monitoring.Routers.monitoring_dashboard extends Backbone.Router
  initialize: (options) ->

  routes:
    "index": "index"
    ".*": "index"

  index: =>
    @view = new Monitoring.Views.SocialContents.SessionsView().render()

